import { css } from '@emotion/css';

export const bankAccountVerificationCx = css`
  display: flex;
  flex-direction: column;
  align-items: center;

  border-radius: 0.5rem;

  padding: 1.5rem 1rem;

  .illustration {
    display: flex;
    margin-bottom: 1rem;
  }

  .title-wrapper {
    text-align: center;
    margin-bottom: 1rem;

    .title {
      color: #00acf0;
      font-weight: 700;
      line-height: 1.5rem;
      margin-bottom: 0.5rem;
    }

    .subtitle {
      color: #616161;
      font-weight: 400;
      font-size: 0.875rem;
      line-height: 1.375rem;
    }
  }

  .action-wrapper {
    width: 100%;
    display: flex;
    > button {
      &:not(:last-of-type) {
        margin-right: 1rem;
      }
      flex: 1;
    }
  }
`;
